import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Input,
  Form,
  Table,
  Spinner,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { postRequestForm, postRequest } from "../../components/Common/Utils.js";
import Lightbox from "react-image-lightbox";
import FileUpload from "components/Common/FileUpload.js";
import CategoryModal from "components/Modal/CategoryModal.js";
import SubCategoryModal from "components/Modal/SubCategoryModal.js";
export default function ChildCategoryCreate() {
  const location = useLocation();
  const state = location.state?.row;
  const [model, setModel] = useState(false);
  const [CategoryData, setCategoryData] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [startLoader, setStartLoader] = useState(false);
  const [SubCategoryallData, setSubCategoryallData] = useState({
    Image: "",
    Text: null,
    subCategoryId:"",
    show:false

  });
  let history = useHistory();

  const { id } = useParams();

  const closeModalCategory = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({item})
    setSubCategoryallData({
      Image: item?.image,
      Title: item?.title,
      subCategoryId:item?._id,
      show:true
    });
    setModel(false);
  };

  const toggleModel = () => {
    setModel(!model);
  };

  useEffect(() => {
    if (!selectedImage) return;
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedImage);
  }, [selectedImage]);

  const showLightBox = (previewImage) => {
    setPreviewImage(previewImage);
    setOpenLightBox(true);
  };

  const ChildCategoryCreateForm = async (e) => {
    e.preventDefault();

    setStartLoader(true);
    setLoading(true);

    const formData = new FormData();
    const selectedImageForm = new FormData();
    selectedImageForm.append("image", selectedImage);
    const selectedImageRes = await postRequestForm(
      "image/img/upload",
      selectedImageForm
    );
    setStartLoader(false);

    formData.append("title", CategoryData.title);
    formData.append("description", CategoryData.description);
    formData.append("subCategoryId", SubCategoryallData.subCategoryId);

    if (selectedImageRes?.data?.url) {
      formData.append("image", selectedImageRes.data.url);
    } else {
      console.error("Image URL not found in the response.");
    }

    const response = await postRequestForm("category/create-Child-category", formData);
    setLoading(false);

    if (response.status) {
      toast.success(response.message);
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const updateValue = (index, value) => {
    const list = { ...CategoryData };
    list[index] = value;
    setCategoryData(list);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Category Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Category Management</li>:{" "}
              <li className="breadcrumb-item">Create Child Category</li>
            </ol>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title"> Child Create Category</h4>

                <Form onSubmit={ChildCategoryCreateForm}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Title
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("title", e.target.value)
                              }
                              value={CategoryData?.title}
                              name="tags"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Description
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("description", e.target.value)
                              }
                              value={CategoryData?.description}
                              name="tags"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Select Sub Category {SubCategoryallData?.Title}
                          </label>

                          <div
                            className="col-sm-6"
                            onClick={() => {
                              toggleModel();
                            }}
                          >
                            {SubCategoryallData.show ? (
                              <div class="input-group">
                                <button
                                  class="btn"
                                  style={{
                                    border: "1px solid #ced4da",
                                    background: "#f08d63",
                                    color: "#ffff",
                                  }}
                                  type="button"
                                  id="chooseCategoryBtn"
                                  onclick={() => toggleModel()}
                                >
                                  Choose  Sub Category
                                </button>
                                <div
                                  style={{
                                    border: "1px solid #ced4da",
                                    width: "16px",
                                  }}
                                ></div>
                                <img
                                  src={SubCategoryallData?.Image}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    border: "1px solid #ced4da",
                                    borderRight: "none",
                                    borderLeft: "none",
                                  }}
                                ></img>
                                <input
                                  type="text"
                                  style={{ borderLeft: "none" }}
                                  class="form-control"
                                  readonly
                                  value={SubCategoryallData?.Title}
                                  id="selectedCategory"
                                  placeholder="No Sub Category chosen"
                                />
                              </div>
                            ) : (
                              <div class="input-group">
                                <button
                                  class="btn"
                                  style={{
                                    border: "1px solid #ced4da",
                                    background: "#f08d63",
                                    color: "#ffff",
                                  }}
                                  type="button"
                                  id="choosesubCategoryBtn"
                                  onclick={() => toggleModel()}
                                >
                                  Choose Sub Category
                                </button>
                                <input
                                  type="text"
                                  class="form-control"
                                  readonly
                                  id="selectedCategory"
                                  placeholder="No Sub Category chosen"
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label
                            htmlFor="horizontal-password-input"
                            className="col-sm-3 col-form-label"
                          >
                            Image
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="file"
                              onChange={(e) =>
                                setSelectedImage(e.target.files[0])
                              }
                              required
                              name="mediaUrl"
                              className="form-control"
                              id="horizontal-password-input"
                            />
                            <br />
                            {previewImage && (
                              <img
                                src={previewImage}
                                onClick={() => showLightBox(previewImage)}
                                style={{ width: "100px", height: "100px" }}
                              />
                            )}
                          </div>
                        </div>

                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button
                                  type="submit"
                                  className="btn btn-primary w-md"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )}
      <SubCategoryModal
        show={model}
        closeModal={closeModalCategory}
        selectRow={selectRow}
      />
     

      <FileUpload message="File Uploading" status={startLoader} />
    </React.Fragment>
  );
}
